import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import { useContext, useEffect, useRef, useState } from 'react';
import { snakeCaseToNormal } from "../../../utils/Utility";
import { ThreeDot, ThreeDot2 } from './ThreeDots';
import { ArrowDropUp, ArrowDropDown } from "@mui/icons-material";


export const TableComp = ({
    Data = [],
    Style = {},
    bundle_id = "",
    rb,
    cb = true,
    btnData = [],
}) => {
    const tblref = useRef()
    const [maxWidth, setMaxWidth] = useState('100%');
const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc"); // asc | desc
    const sanitizedData = Array.isArray(Data) ? Data : [];
    const Head =
        sanitizedData && sanitizedData.length > 0
            ? Object.keys(sanitizedData[0])
            : [];
    const Row =
        Head && Head.length > 0
            ? Head.map((x) => ({
                title: snakeCaseToNormal(x),
                field: x,
            }))
            : [];
// Handle sorting
  const handleSort = (field) => {
    if (sortField === field) {
      // toggle order
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };
  // Apply sorting
  const sortedData = [...sanitizedData].sort((a, b) => {
    if (!sortField) return 0;

    const valA = a[sortField];
    const valB = b[sortField];

    if (valA == null) return 1;
    if (valB == null) return -1;

    if (typeof valA === "number" && typeof valB === "number") {
      return sortOrder === "asc" ? valA - valB : valB - valA;
    }

    return sortOrder === "asc"
      ? String(valA).localeCompare(String(valB))
      : String(valB).localeCompare(String(valA));
  });

    /*
      const Style = {
          table: {},
          head: {},
          headRow: {},
          headCell: {},
          body: {},
          row: {},
          cell: {},
      }
      
      */
    const updateMaxWidth = () => {
        if (tblref.current) {
            setMaxWidth(`${tblref.current.offsetWidth}px`);
        } else {
            setMaxWidth('100%');
        }
    };

    useEffect(() => {
        // Initial calculation
        updateMaxWidth();

        // Add event listener for window resize
        window.addEventListener('resize', updateMaxWidth);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', updateMaxWidth);
        };
    }, []);


    return (
        <Box
            ref={tblref}
            sx={{
                overflowY: "auto",
                overflowX: "auto",
                // scrollbarWidth: 'none',
                border: "0.8px solid #E7E8EA",
                borderRadius: "8px",
                width: "100%",
                maxWidth: Style.StrictMaxWidth && tblref.current ? maxWidth : '100%',
                ...(Style.OutBox ? { ...Style.OutBox } : {}),
            }}
        >
            <TableContainer
                component={Paper}
                sx={{ width: "100%", scrollbarWidth: 'thin', maxWidth: Style.StrictMaxWidth && tblref.current ? maxWidth : '100%', ...(Style.TableContainer ? { ...Style.TableContainer } : {}), }}
            >
                <Table
                    aria-label="brand table"
                    sx={{
                        borderRadius: "25px",
                        width: '100%',
                        maxWidth: Style.StrictMaxWidth && tblref.current ? maxWidth : '100%',
                        ...(Style.table ? { ...Style.table } : {}),
                    }}
                >
                    {/* <Table aria-label="brand table" sx={{ border: '1px solid #E1E1E1', borderRadius: '25px', ...(Style.table ? { ...Style.table } : {}) }}> */}
                    <TableHead sx={{ ...(Style.head ? { ...Style.head } : {}) }}>
                        <TableRow sx={{ ...(Style.headRow ? { ...Style.headRow } : {}) }}>
                            {Row.map((row, i) => (
                                <TableCell
                                    key={i}
                                    onClick={() => handleSort(row.field)}
                                    sx={{ ...(Style.headCell ? { ...Style.headCell } : {}) }}
                                >
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                    {row.title}
                    {sortField === row.field && (
                      <>
                        {sortOrder === "asc" ? (
                          <ArrowDropUp fontSize="small" />
                        ) : (
                          <ArrowDropDown fontSize="small" />
                        )}
                      </>
                    )}
                  </Box>
                                </TableCell>
                            ))}
                            {Style.isThreeDot && (
                                <TableCell
                                    sx={{
                                        ...(Style.headCell ? { ...Style.headCell } : {}),
                                    }}
                                ></TableCell>
                            )}
                            {Style.isThreeDot2 && (
                                <TableCell
                                    sx={{
                                        ...(Style.headCell ? { ...Style.headCell } : {}),
                                    }}
                                ></TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody
                        sx={{ overflow: "auto", ...(Style.body ? { ...Style.body } : {}) }}
                    >
                        {sortedData.map((row, i) => (
                            <TableRow
                                key={i}
                                sx={{
                                    "&:last-child td, &:last-child th": { border: 0 },
                                    ...(Style.oddEvenColor
                                        ? { background: i % 2 !== 0 ? "#FAFAFA" : "#FFFFFF" }
                                        : {}),
                                    ...(Style.row ? { ...Style.row } : {}),
                                }}
                            >
                                {Row.map((col, j) => (
                                    <TableCell
                                        key={j}
                                        sx={{ ...(Style.cell ? { ...Style.cell } : {}) }}
                                    >
                                        {Array.isArray(row[col.field]) ? (
                                            <Box>
                                                {row[col.field].map((e, i) => (
                                                    <Box key={i} sx={{ my: 1 }}>
                                                        {e}
                                                    </Box>
                                                ))}
                                            </Box>
                                        ) : (
                                            row[col.field]
                                        )}
                                    </TableCell>
                                ))}
                                {Style.isThreeDot && Row[0].field !== null && (
                                    <TableCell
                                        sx={{ ...(Style.threeDot ? { ...Style.threeDot } : {}),
            padding: '0px 10px',
            verticalAlign: 'middle',
            height: '100%' }}
                                    >
                                        <ThreeDot
                                            bundle_id={bundle_id}
                                            rb={rb}
                                            cb={cb}
                                            data={btnData}
                                        />
                                    </TableCell>
                                )}

                                {Style.isThreeDot2 && row[Row[0].field] !== null && (
                                    <TableCell
                                        sx={{ ...(Style.threeDot ? { ...Style.threeDot } : {}),
            padding: '-1px 16px',
            verticalAlign: 'middle',
            height: '100%' }}
                                    >
                                        <ThreeDot2
                                            bundle_id={bundle_id}
                                            rb={rb}
                                            cb={cb}
                                            data={btnData}
                                            rowData={row}
                                            i={i}
                                        />
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};
